var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"switch-wrap",class:{ 'is-disabled': _vm.disabled, 'is-checked': _vm.checked },on:{"click":_vm.switchValue}},[_c('span',{ref:"core",staticClass:"switch-bar"},[_c('span',{staticClass:"switch-point"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }